module.exports = __webpack_public_path__ + "img/h6.ac38173a.png";